// extracted by mini-css-extract-plugin
module.exports = {"root":"divider_root__2tDJO","video-spin":"divider_video-spin__EpXEX"};